import { useCallback, useState } from 'react';

interface PaginationState {
  pageUrl: string | null;
  offsets: number[];
}

const initialState: PaginationState = { pageUrl: null, offsets: [0] };

export function useBusinessPagination() {
  const [state, setState] = useState(initialState);

  const resetPagination = useCallback(() => setState(initialState), []);

  const nextPage = useCallback((pageUrl: string, rowCount: number) => {
    setState((current) => ({
      pageUrl,
      offsets: [...current.offsets, current.offsets[current.offsets.length - 1] + rowCount],
    }));
  }, []);

  const previousPage = useCallback((pageUrl: string) => {
    setState((current) => ({
      pageUrl,
      offsets: current.offsets.length > 1 ? current.offsets.slice(0, -1) : current.offsets,
    }));
  }, []);

  return {
    pageUrl: state.pageUrl,
    offset: state.offsets[state.offsets.length - 1],
    nextPage,
    previousPage,
    resetPagination,
  };
}
